var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmojiSadColored(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93541 10.5097C7.40094 10.5097 6.96767 10.0764 6.96767 9.54192V8.76773C6.96767 8.23327 7.40094 7.8 7.93541 7.8C8.46988 7.8 8.90314 8.23327 8.90314 8.76773V9.54192C8.90314 10.0764 8.46988 10.5097 7.93541 10.5097Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0644 10.5097C15.5299 10.5097 15.0967 10.0764 15.0967 9.54192V8.76773C15.0967 8.23327 15.5299 7.8 16.0644 7.8C16.5989 7.8 17.0321 8.23327 17.0321 8.76773V9.54192C17.0321 10.0764 16.5989 10.5097 16.0644 10.5097Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.12753 17.5162C8.01034 17.5162 7.89278 17.4738 7.79978 17.3884C7.60319 17.2073 7.59034 16.9013 7.77142 16.7045C8.75355 15.6372 10.334 15 11.9985 15C13.6637 15 15.2438 15.6374 16.2255 16.7047C16.4066 16.9013 16.3938 17.2075 16.1972 17.3884C16.001 17.5695 15.6944 17.5572 15.5133 17.3598C14.7115 16.4881 13.3975 15.9677 11.9984 15.9677C10.5997 15.9677 9.28572 16.4881 8.48355 17.36C8.38839 17.4637 8.25794 17.5162 8.12753 17.5162Z",
    fill: "#333333"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiSadColored);
export default __webpack_public_path__ + "static/media/emoji-sad-colored.987e9d6c0e5f4d0e656cf8bc63198408.svg";
export { ForwardRef as ReactComponent };